import React from 'react';
import { Menu } from 'antd';
import { useOpenCreateDeskModal } from '../../../controllers/SetDeskName';

const CreateDeskNameOption = ({ onClose, ...props }) => {
  const openCreateDeskModal = useOpenCreateDeskModal();

  const handleClick = () => {
    openCreateDeskModal();
    onClose();
  };

  return (
    <Menu.Item {...props} onClick={handleClick}>
      Создать новый стол
    </Menu.Item>
  );
};

export default CreateDeskNameOption;
